import React, { ReactNode } from 'react';
import EyeIcon from '@/public/icons/approval/eye.svg';
import { HeaderWrap, IconSlot, Label } from './styles';

type P = {
  label: string;
  icon?: ReactNode;
};

/** 참조인 영역 헤더 — 역할별 재사용 시 icon prop 으로 교체 */
const Header = ({ label, icon }: P) => {
  return (
    <HeaderWrap>
      <IconSlot aria-hidden>
        {icon ?? (
          <EyeIcon
            width={16}
            height={16}
            style={{ ['--icon-stroke-width' as any]: 1 }}
          />
        )}
      </IconSlot>
      <Label>{label}</Label>
    </HeaderWrap>
  );
};

export default Header;
